module.exports = __webpack_public_path__ + "static/img/chinams.50e5243a.png";